import $ from "jquery";
export class DataTableUtils {

    public static getColumnDefsSettings(dataTable: DataTables.Api, idx: number): DataTables.ColumnDefsSettings {
        let def = null;
        $.each(dataTable.settings().init().columnDefs, (key, val) => {
            if (val.targets === idx) {
                def = val;
                return;
            }
        });
        return def;
    }

    public static getColumnProperty(dataTable, idx: number): string {
        const def = DataTableUtils.getColumnDefsSettings(dataTable, idx);
        if (def == null) {
            return null;
        }
        return (def as any).property;
    }
}
